var CartChannelService = (function () {
    function CartChannelService($q) {
        this.$q = $q;
        this.initialized = false;
        this.onAddDefer = $q.defer();
        this.onRemoveDefer = $q.defer();
        this.onInitDefer = $q.defer();
    }
    CartChannelService.prototype.add = function (items) {
        this.onAddDefer.notify(items);
    };
    CartChannelService.prototype.reInit = function () {
        this.onInitDefer = this.$q.defer();
        return this;
    };
    CartChannelService.prototype.init = function (items) {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        this.onInitDefer.resolve(items);
    };
    CartChannelService.prototype.remove = function (items) {
        this.onRemoveDefer.notify(items);
    };
    CartChannelService.prototype.onAdd = function () {
        return this.onAddDefer.promise;
    };
    CartChannelService.prototype.onInit = function () {
        return this.onInitDefer.promise;
    };
    CartChannelService.prototype.onRemove = function () {
        return this.onRemoveDefer.promise;
    };
    CartChannelService.$inject = ['$q'];
    return CartChannelService;
}());
export { CartChannelService };
